// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"465":"css/app.6984","8410":"css/admin-app.6984"}[chunkId] + ".css";
};